import React from 'react';
import AppStore from '../stores/AppStore';
import TemplateData from '../utility/getTemplateData';
import { trackConfirmationPageIM } from '../fpti/fpti';

const PAGE_TRACK_TAG = 'main:donate:wps:';

export default function withPageTrack(WrappedComponent, flow, result) {
  return class extends React.Component {
    componentDidMount() {
      const confData = AppStore.getConfirmation() || {};
      const isSignUp =
        flow !== 'member' &&
        (confData.showAccountOverview ||
          confData.signUpSuccess ||
          TemplateData.fptPageName === 'guestULSignUp');

      if (TemplateData.onboardingEnabled) {
        flow = 'signup';
      }

      const isGuestUpgrade =
        flow === 'guest' &&
        !TemplateData.onboardingEnabled &&
        (confData.showAccountOverview || confData.signUpSuccess);
      if (isGuestUpgrade) {
        result = 'upgrade';
      }

      let tag = `${PAGE_TRACK_TAG}${flow}:${result}`;
      trackConfirmationPageIM({
        isSignUp,
        pageSpec: {
          pgrp: tag,
          page: `${tag}:web::`,
          tmpl: `${tag}:web::`,
        },
        flow,
        confirmationData: confData,
      });
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
